import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    gridNavOpen: {
        width: 'calc(100% - 240px)',
    },
    root: {
        height: '100%',
    },
}));
